import {createSlice} from "@reduxjs/toolkit";



interface IInitState {
    query: string | undefined
    is_active: boolean | undefined
    page:number | undefined

}

const initialState: IInitState = {
    query: undefined,
    is_active: undefined,
    page:1,


}

const doctorReducer = createSlice({
    name: 'doctor',
    reducers: {
        setFilterData: (state, {payload}) => {
            if (payload.query || payload.query === '') {
                state.query = payload.query
            }
            if (payload.is_active || payload.is_active !== 'all') {
                state.is_active = payload.is_active
            }
            if (payload.is_active === 'all') {
                state.is_active = undefined
            }
            if (payload.page||payload.page===undefined) {
                state.page = payload.page
            }
        },
        clearFilterData: (state) => {
            state.query = undefined
            state.is_active = undefined
            state.page = undefined
        },
        clearFilterQuery: (state) => {
            state.query = undefined
            state.is_active = undefined
        },




    },
    initialState,

})

export const {setFilterData, clearFilterData, clearFilterQuery} = doctorReducer.actions
export default doctorReducer.reducer
